import PropTypes from 'prop-types';
import { Box, Button, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AccessTimeFilledSharpIcon from '@mui/icons-material/AccessTimeFilledSharp';
import NotificationsOffSharpIcon from '@mui/icons-material/NotificationsOffSharp';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import BasicModal from '../../../../components/common/BasicModal';

const ContentCard = ({ icon, title, description, customStyle }) => {
	return (
		<Box
			display='flex'
			flexDirection='row'
			gap={2}
			sx={{
				padding: 2,
				borderRadius: '8px',
				...customStyle, // appends fields to customize colors on each card
			}}
		>
			{icon}
			<Box>
				<Typography fontWeight={600}>{title}</Typography>
				<Typography>{description}</Typography>
			</Box>
		</Box>
	);
};

ContentCard.propTypes = {
	icon: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	customStyle: PropTypes.object,
};

const AlertSubscriptionInfoModal = ({ open, onClose }) => (
	<BasicModal
		open={open}
		onClose={onClose}
		title='How alert subscriptions work'
		titleIcon={<InfoOutlinedIcon fontSize='small' />}
		actions={
			<Button variant='outlined' onClick={onClose}>
				Got it
			</Button>
		}
	>
		<Stack spacing={4}>
			<ContentCard
				icon={<NotificationsActiveIcon />}
				title="Subscribed - you'll see it in your Alerts panel"
				description="When you're subscribed to an alert, any time it's triggered you'll receive an alert for it in your Alerts panel."
				customStyle={{
					backgroundColor: 'status.blue.bg',
					color: 'status.blue.text',
					border: '0.5px solid',
					borderColor: 'primary.main',
				}}
			/>

			<ContentCard
				icon={<NotificationsOffSharpIcon />}
				title='Not subscribed - nothing reaches your Alerts panel'
				description="If you're not subscribed to an alert, you won't receive anything in your Alerts panel related to that alert, even if it's triggered."
				customStyle={{
					backgroundColor: 'background.default',
					color: 'text.primary',
					border: '0.5px solid',
					borderColor: 'divider',
				}}
			/>

			<ContentCard
				icon={<AccessTimeFilledSharpIcon />}
				title="It's a point-in-time setting - nothing is backfilled or removed"
				description="Unsubscribing from an alert will not delete any existing alerts you've already received. Subscribing to an alert will not backfill alerts for anything that was triggered before you subscribed."
				customStyle={{
					backgroundColor: 'status.amber.bg',
					color: 'status.amber.text',
					border: '0.5px solid',
					borderColor: 'status.amber.border',
				}}
			/>
		</Stack>
	</BasicModal>
);

AlertSubscriptionInfoModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default AlertSubscriptionInfoModal;
